import {
  Project,
  ProjectVirtualGraph,
  ProjectsState,
} from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * * on {@link ProjectVirtualGraph} update `SPARK` data source type to `DATABRICKS_SPARK`
 * * on {@link ProjectVirtualGraph} update undefined data source type to `null`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v7 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v7Projects(prevState.projects);
  }

  return nextState;
};

const v7Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    const virtualGraphsById: Record<string, ProjectVirtualGraph> = {};

    Object.entries(project.virtualGraphsById).forEach(
      ([id, { dataSourceType, ...virtualGraph }]) => {
        virtualGraphsById[id] = {
          ...virtualGraph,
          dataSourceType:
            (dataSourceType as string) === 'SPARK'
              ? 'DATABRICKS_SPARK'
              : dataSourceType || null,
          connectionId: null,
        };
      }
    );
    projectsById[projectId] = {
      ...project,
      virtualGraphsById,
    };
  });

  return { ...prevProjectsState, projectsById };
};
